
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as HomeV9rRnWrma5b2GR85lfotTpf7rNiOODAtDB028lwSX2sMeta } from "/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/Home.vue?macro=true";
import { default as BrowseD1a1uNgw7reiViM2P2NLIQBv_Ci2ipxqf4co1RNW_XUMeta } from "/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/Browse.vue?macro=true";
import { default as SearchziNpBWPw_kLqg8pYLHinUmfdA3LbIU7JsOvOZONb4k4Meta } from "/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/Search.vue?macro=true";
import { default as PageNotFound8TwiWZpVJl_IGstfGEj2y5AIqFyiFaqQdzJRdLi7tCwMeta } from "/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/PageNotFound.vue?macro=true";
import { default as MainLandingPageYoIpWej_jkVAr4mb8IlW2ibgdcAS4hTVwCPgnFPaii0Meta } from "/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/MainLandingPage.vue?macro=true";
export default [
  {
    name: "Home",
    path: "/Home",
    component: () => import("/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/Home.vue")
  },
  {
    name: "Browse",
    path: "/Browse",
    component: () => import("/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/Browse.vue")
  },
  {
    name: "Search",
    path: "/Search",
    component: () => import("/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/Search.vue")
  },
  {
    name: "PageNotFound",
    path: "/PageNotFound",
    component: () => import("/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/PageNotFound.vue")
  },
  {
    name: "MainLandingPage",
    path: "/MainLandingPage",
    component: () => import("/builds/macys/polaris/nuxt-app/discovery-ui/app/pages/MainLandingPage.vue")
  }
]